// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 280px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 24px;
  text-align: center;
  max-width: 320px;
  animation: fadeInUp 0.4s ease;
}
.empty-state__illustration {
  width: 100%;
  display: flex;
  justify-content: center;
}
.empty-state__image {
  max-width: 180px;
  max-height: 180px;
  object-fit: contain;
}
@media (min-width: 768px) {
  .empty-state__image {
    max-width: 240px;
    max-height: 240px;
  }
}
.empty-state__text {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: var(--font);
}
.empty-state__title {
  font-weight: 600;
  font-size: 17px;
}
.empty-state__description {
  font-weight: 400;
  font-size: 14px;
  opacity: 0.7;
  line-height: 1.4;
}
.empty-state__action {
  margin-top: 8px;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .empty-state {
    animation: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/documents/document-empty-state/document-empty-state.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AACJ;AAEE;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;AAAJ;AAEI;EALF;IAMI,gBAAA;IACA,iBAAA;EACJ;AACF;AAEE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,wBAAA;AAAJ;AAGE;EACE,gBAAA;EACA,eAAA;AADJ;AAIE;EACE,gBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AAFJ;AAKE;EACE,eAAA;AAHJ;;AAOA;EACE;IACE,UAAA;IACA,2BAAA;EAJF;EAMA;IACE,UAAA;IACA,wBAAA;EAJF;AACF;AAOA;EACE;IACE,eAAA;EALF;AACF","sourcesContent":[":host {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  min-height: 280px;\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 32px 24px;\n  text-align: center;\n  max-width: 320px;\n  animation: fadeInUp 0.4s ease;\n\n  &__illustration {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n\n  &__image {\n    max-width: 180px;\n    max-height: 180px;\n    object-fit: contain;\n\n    @media (min-width: 768px) {\n      max-width: 240px;\n      max-height: 240px;\n    }\n  }\n\n  &__text {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    font-family: var(--font);\n  }\n\n  &__title {\n    font-weight: 600;\n    font-size: 17px;\n  }\n\n  &__description {\n    font-weight: 400;\n    font-size: 14px;\n    opacity: 0.7;\n    line-height: 1.4;\n  }\n\n  &__action {\n    margin-top: 8px;\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(16px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .empty-state {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
